<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Возврат с лицевого счета</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол / Возврат /</span> Возврат с лицевого счета</div>
                </div>
              </v-col>
              <v-col>
                <v-sheet class="card rounded-lg" style="padding: 0 !important;">
                  <div class="column" style="padding-top: 20px !important;">
                    <VueDatePicker
                        no-title
                        no-header
                        color="#629f34"
                        v-model="date"
                        style="flex: none !important;"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__button"
                            ref="activator"
                            type="button"
                        >
                          <v-icon
                              dark
                              right
                              small
                              class="mr-2"
                          >
                            mdi-calendar-blank-outline
                          </v-icon>
                          {{ date }}
                        </button>
                      </template>
                    </VueDatePicker>
                  </div>
                  <div class="column mt-5">
                    {{ client.name }}
                  </div>
                  <v-data-table
                      :headers="headersReturn"
                      :items="products ? products.products : []"
                      item-key="buy_id"
                      v-model="selectReturn"
                      no-data-text="Ничего не найдено"
                      hide-default-footer
                      show-select
                      class="elevation-1 mt-5 custom__table"
                  >
                  </v-data-table>
                  <div class="column mt-5" style="padding-bottom: 20px !important;">
                    <template v-if="selectReturn.length > 0">
                      <v-btn
                          dark
                          class="apply-button"
                          style="background-color: #A13453 !important; color: #FFFFFF!important;"
                          @click="dialogModal = true"
                      >
                        Применить
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn
                          dark
                          class="apply-button"
                      >
                        Применить
                      </v-btn>
                    </template>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogModal"
              persistent
              max-width="400px"
          >
            <v-card>
              <v-card-title class="text-center">
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogModal = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text style="padding-bottom: 30px;">
                <v-container>
                  <div>
                    <h3 class="card-title">Вы уверены, что хотите сделать возврат?</h3>
                  </div>
                  <v-row
                      align="center"
                      class="mt-5 justify-center"
                  >
                    <button
                        class="button button__danger"
                        ref="activator"
                        type="button"
                        @click="dialogModal = false"
                    >
                      Да
                    </button>
                    <button
                        class="button button__unlock ml-5"
                        ref="activator"
                        type="button"
                        @click="dialogModal = false"
                    >
                      Нет
                    </button>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import {returnActionTypes} from '@/store/modules/return';
import {mapState} from "vuex";
import {getItem, setItem} from "../helpers/persistanceStorage";

export default {
  name: "ReturnFromBill",
  props: ['client'],
  components: {
    Header,
    Menu,
    VueDatePicker
  },
  computed: {
    ...mapState({
      products: state => state.refund.products
    })
  },
  data() {
    return {
      date: new Date(),
      selectReturn: [],
      dialogModal: false,
      headersReturn: [
        {text: 'Дата', align: 'start', sortable: false, value: 'date', width: '15%'},
        {text: 'Товары и услуги', align: 'start', value: 'buy_name', width: '70%'},
        {text: 'Сумма для возврата', align: 'start', value: 'sum', width: '15%'},
      ]
    }
  },
  methods: {
    fetchFeed(client_id, date) {
      this.$store.dispatch(returnActionTypes.getReturnProducts, {
        client_id,
        date
      })
    }
  },
  mounted() {
    this.client !== undefined ? setItem('return-client',JSON.stringify(this.client)) : this.client = this.client = JSON.parse(getItem('return-client'));
    this.fetchFeed(this.client.client_id, this.date);
  },
  watch: {
    date() {
      this.$store.dispatch(returnActionTypes.getReturnProducts, {
        client_id: this.client.client_id,
        date: this.date
      })
    }
  }
}
</script>

<style scoped>
.custom__button {
  width: 180px;
  height: 30px;
  display: flex;
  padding: 7px;
  max-width: 180px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  margin-right: 0;
  border-radius: 12px;
  margin-bottom: 0;
  justify-content: center;
  background-color: var(--dl-color-default-primarysuccess);
  font-size: 16px;
  line-height: 24px;
  color: #fff !important;
}

.column {
  display: flex;
  justify-content: center;
  width: 100%;
}

.card-title {
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
  padding: 0 25px;
}
</style>